export const AUTH_TOKEN_PARAM = "authToken";

export interface AuthConfig {
    USERS_COLLECTION: string;
}

const authConfig: AuthConfig = {
    USERS_COLLECTION: "customers",
}
export default authConfig;